import { Base } from '@studiometa/js-toolkit';

/**
* StickyBar

*/
export default class betterDocs extends Base {
  static config = {
    name: 'betterDocs',
    refs: ['close[]'],
  };

  mounted() {
    const faqs = this.$el.querySelectorAll('.faq__item');
    this.initialVisibleCount = 5;

    if (faqs.length > this.initialVisibleCount) {
      // Masquer tous les éléments sauf les premiers
      faqs.forEach((faq, index) => {
        if (index >= this.initialVisibleCount) {
          faq.classList.add('tw-hidden');
        }
      });

      this.injectToggleButton(faqs);
    }
  }

  /**
   * Inject the toggle button to show/hide the FAQs
   * @param {NodeList} faqs - The FAQs to toggle
   */
  injectToggleButton(faqs) {
    const button = document.createElement('button');
    button.classList.add(
      'show-more-button', 'tw-mt-6', 'tw-w-full', 'tw-text-center',
      'tw-text-sm', 'tw-font-medium', 'tw-text-grey-black',
      'tw-underline', 'tw-underline-offset-4'
    );
    button.textContent = 'Voir plus de questions';
    this.$el.appendChild(button);

    button.addEventListener('click', () => {
      const areHidden = [...faqs].slice(this.initialVisibleCount).some(faq =>
        faq.classList.contains('tw-hidden')
      );

      faqs.forEach((faq, index) => {
        if (index >= this.initialVisibleCount) {
          faq.classList.toggle('tw-hidden', !areHidden);
        }
      });

      button.textContent = areHidden
      ? 'Voir moins de questions'
      : 'Voir plus de questions';

      this.$el.scrollIntoView({ behavior: 'smooth' });
    });
  }


}
